import React from 'react';

export const BeersPlaceholder = () => {
  return (
    <svg width="320" height="320" viewBox="0 0 320 320" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="320" height="320" rx="3" fill="#404045" />
      <circle cx="159.999" cy="160" r="113.171" fill="white" />
      <mask id="mask0_10339_45818" maskUnits="userSpaceOnUse" x="46" y="46" width="228" height="228">
        <circle cx="159.999" cy="160" r="113.171" fill="white" />
      </mask>
      <g mask="url(#mask0_10339_45818)" />
      <path d="M99 123.316H221V132.948H99V123.316Z" fill="#FFBF17" />
      <path d="M99 187.526H221V197.159H99V187.526Z" fill="#FFBF17" />
      <path
        d="M217.022 182.711C218.035 175.488 218.588 167.973 218.588 160.238C218.588 152.501 218.034 144.986 217.022 137.764H196.656C197.249 144.975 197.573 152.487 197.573 160.238C197.573 167.994 197.239 175.495 196.645 182.711H217.022Z"
        fill="#FFBF17"
      />
      <path
        d="M213.01 118.5C209.756 106.944 205.212 96.5945 199.66 88H186.477C189.752 96.6994 192.41 107.018 194.307 118.5H213.01Z"
        fill="#FFBF17"
      />
      <path
        d="M191.451 160.237C191.451 152.366 191.125 144.868 190.537 137.764H161.605V182.711H190.532C191.117 175.601 191.45 168.109 191.45 160.237H191.451Z"
        fill="#FFBF17"
      />
      <path
        d="M120.821 160.237C120.821 152.485 121.144 144.974 121.738 137.764H101.371C100.358 144.986 99.8047 152.502 99.8047 160.237C99.8047 167.973 100.359 175.489 101.371 182.71H121.748C121.155 175.494 120.821 167.993 120.821 160.237H120.821Z"
        fill="#FFBF17"
      />
      <path
        d="M155.187 137.763H127.864C127.275 144.868 126.949 152.365 126.949 160.236C126.949 168.108 127.282 175.6 127.867 182.709H155.187L155.187 137.763Z"
        fill="#FFBF17"
      />
      <path d="M188.165 118.5C186.158 106.581 183.348 96.2932 180.039 88H161.605V118.5H188.165Z" fill="#FFBF17" />
      <path
        d="M161.605 201.974V232.474H180.038C183.348 224.182 186.157 213.893 188.164 201.974H161.605Z"
        fill="#FFBF17"
      />
      <path
        d="M194.307 201.974C192.409 213.454 189.75 223.775 186.477 232.474H199.66C205.211 223.88 209.756 213.529 213.01 201.974H194.307Z"
        fill="#FFBF17"
      />
      <path d="M155.183 118.5V88H138.357C135.047 96.2929 132.237 106.581 130.23 118.5H155.183Z" fill="#FFBF17" />
      <path
        d="M130.23 201.974C132.237 213.892 135.048 224.183 138.357 232.474H155.184V201.974H130.23Z"
        fill="#FFBF17"
      />
      <path
        d="M124.086 118.5C125.984 107.017 128.642 96.6985 131.916 88H118.732C113.182 96.5939 108.637 106.944 105.383 118.5H124.086Z"
        fill="#FFBF17"
      />
      <path
        d="M105.379 201.974C108.633 213.528 113.177 223.879 118.728 232.474H131.912C128.637 223.774 125.979 213.455 124.082 201.974H105.379Z"
        fill="#FFBF17"
      />
    </svg>
  );
};
